export default __webpack_public_path__ + "static/Inbox-3@2x-d3f2367f92920d2805504ff3a4b987a6.svg";